// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1IMh-","unreadBadge":"styles_unreadBadge__2sEKn","modalContent":"styles_modalContent__2nZ_a","modal":"styles_modal__7z5vT"};